import { type SocketMachineContext } from '../../../network-state-machine-context';
import { type AuthenticatedEvent } from '../../../network-state-machine-events';

export async function authenticatingAsync<
  C extends Pick<SocketMachineContext, 'relaySupplier' | 'debounce'>
>(ctx: C, signal: AbortSignal): Promise<AuthenticatedEvent> {
  const { url, accessToken } = await ctx.relaySupplier(
    ctx.debounce.onlineAttempts,
    signal
  );

  return {
    type: 'authenticated',
    relayDetails: {
      url,
      accessToken,
    },
  };
}
